var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-item" }, [
    _c("div", { staticClass: "cart-item__delete-button-wrapper" }, [
      _c("button", {
        staticClass: "close-button",
        attrs: { "aria-label": "Delete item" },
        on: {
          click: function ($event) {
            return _vm.$emit("delete", _vm.item)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cart-item__inner" }, [
      _vm.item.designs.length > 1
        ? _c(
            "div",
            { staticClass: "cart-item__thumbnail-carousel" },
            [
              _c(
                "vue-glide",
                {
                  ref: "carousel",
                  attrs: { "per-view": 1 },
                  on: { "glide:run": _vm.handleGlideRun },
                },
                [
                  _vm._l(_vm.item.designs, function (design, index) {
                    return _c("vue-glide-slide", { key: index }, [
                      _c("img", { attrs: { src: design.thumbnail, alt: "" } }),
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "control" },
                    _vm._l(_vm.item.designs.length, function (i) {
                      return _c("button", {
                        staticClass: "cart-item__carousel-bullet",
                        attrs: {
                          "aria-label": `Go to slide thumbnail ${i}`,
                          "data-glide-dir": `=${i - 1}`,
                        },
                      })
                    }),
                    0
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _c("div", { staticClass: "cart-item__thumbnail" }, [
            _c("img", {
              attrs: { src: _vm.item.designs[0].thumbnail, alt: "" },
            }),
          ]),
      _vm._v(" "),
      _c("div", [
        !_vm.isValidQuantity
          ? _c("p", { staticClass: "cart-item__sheet-error" }, [
              _vm._v("\n        Sheet not complete\n      "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "cart-item__name" }, [
          _vm._v("\n        " + _vm._s(_vm.item.name) + "\n      "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cart-item__quantity-wrapper" },
          [
            _c("Quantity", {
              attrs: { value: _vm.item.quantity },
              on: { change: _vm.updateQuantity },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "cart-item__edit-sheet",
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit", _vm.item)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.item.metaData.isSheet ? "Edit Sheet" : "Edit") +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticClass: "cart-item__price" }, [
          _vm._v("\n        " + _vm._s(_vm.item.price) + "\n      "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }